import React from "react";
import "./QuantityInput.scss";

/**
 *
 * @param {Number|String} [value]
 * @param {Boolean} [isLocked]
 * @param {Function} [onChange]
 * @param {Number} [maximumAmount]
 */
export default function QuantityInput({ value, isLocked, onChange, maximumAmount }) {
	const [innerValue, setInnerValue] = React.useState(value ?? 0);
	const bufferTimer = React.useRef(undefined);
	const inputRef = React.useRef(undefined);
	const [isProcessing, setIsProcessing] = React.useState(undefined);

	const dispatchChange = async () => {
		if (typeof onChange === "function") {
			setIsProcessing(true);
			const value = +(inputRef.current?.value ?? "0");
			inputRef.current.value = value === 0 ? 0 : Math.max(0, maximumAmount ?? 0, value ?? 0);
			
			await onChange(value);
			setIsProcessing(false);
		}
	}

	const bufferDispatchChange = () => {
		clearTimeout(bufferTimer.current);
		bufferTimer.current = setTimeout(() => dispatchChange(), 500);
	}

	const incrementValue = e => {
		e.preventDefault();
		inputRef.current.value = +(inputRef.current?.value ?? "0") + 1;
		setInnerValue(inputRef.current.value);
		bufferDispatchChange();
	}

	const decrementValue = e => {
		e.preventDefault();
		
		const value = +(inputRef.current?.value ?? "0") - 1;
		inputRef.current.value = value === 0 ? 0 : Math.max(0, maximumAmount ?? 0, value);
		setInnerValue(inputRef.current.value);
		bufferDispatchChange();
	}

	const handleInputChange = event => {
		const val = Math.max(0, +inputRef.current.value);
		setInnerValue(val);
		inputRef.current.value = val;
		bufferDispatchChange();
	}

	return (
		<>
			{isLocked
				? (
					<div className="quantity-input locked">{innerValue || ""}</div>
				)
				: (
					<div
						data-component="QuantityInput"
						data-value={innerValue}
						data-source-value={value}
						className={[
							'quantity-input',
							value != null && "in-order",
							innerValue > 0 && 'has-value',
							value <= 0 && "is-removing",
						].filter(f => f).join(' ')}
					>
						<button
							type="button"
							aria-label="Decrease Quantity"
							className="iconable button-decrement border-0 rounded-circle icon-shape icon-sm"
							onClick={decrementValue}
							data-field="quantity"></button>
						
						<div className={["input-container", (isProcessing || innerValue < 0) && "processing"].filter(f => f).join(' ')}>
							<div className="removing-placeholder">...</div>
							<input
								ref={inputRef}
								type="number"
								aria-label="Quantity"
								step="1"
								max={maximumAmount ?? 10}
								onBlur={handleInputChange}
								defaultValue={innerValue}
								name="quantity"
								className="quantity-field border-0 text-center w-25"
							/>
						</div>
						
						{ (!maximumAmount || innerValue < maximumAmount) && (
							<button
								type="button"
								aria-label="Increase Quantity"
								onClick={incrementValue}
								className="iconable button-plus border-0 rounded-circle icon-shape icon-sm"
								data-field="quantity"></button>
						)}
					</div>
				)}
		</>
	);
}
